import React, { Component } from 'react';
import Paper from '../common/paper';
import Markdown from '../common/markdown';

export default class AkasseArticle extends Component {
  render() {
    return (
      <Paper>
        <Markdown>{`
# A-kasse

### Hvad er en a-kasse?

En a-kasse er en statsstøttet organisation, der forsikre mod arbejdsløshed mod betaling på et fast beløb hver måned. Er du medlem af en a-kasse, vil du, i tilfælde af arbejdsløshed, blive tilbudt dagpenge. Ordet a-kasse er en forkortelse af arbejdsløshedskasse, men det er ikke kun arbejdsløshed, som a-kasserne tager sig af. A-kasser administrerer nemlig også offentlige love og regler på området og sørger for en række ydelser som f.eks. udbetaling af efterløn og feriedagpenge.

Der er mange a-kasser i Danmark. Nogle a-kasser er målrettet folk med bestemte erhverv. Er du eksempelvis leder. så har Lederne både en a-kasse og en fagforening at tilbyde dig, og er du akademier, har akademikernes a kasse en a-kasse at tilbyde dig.

### Vælge en billig A-kasse eller ej?

Når du skal vælge a-kasse, er det værd at vide, at ens valg ingen betydning har for hvor meget du kan få udbetalt i dagpenge i tilfælde af, at du bliver arbejdsløs. Du får udbetalt det samme, uanset om du er medlem af en dyr eller billig a-kasse.

Medlemskontingentet til a-kasser består af to bidrag. Et et medlems- og ATP-bidrag til staten. Dette bidrags størrelse er ens for alle a-kasser og dets medlemmer - samt et bidrag til administration som går til a-kassen. Størrelsen på dette bidrag fastsætter den enkelte a-kasse selv. Forskellen i prisen på medlemskaber hos a-kasser har altså ingenting med udbetaling af dagpenge at gøre. Det du betaler ekstra for i dit kontingent er bidraget til administrationen, der også dækker over forskellige former for services.

Det kan godt betale sig ikke at vælge den første og billigste a-kasse, da der kan være stor forskel på, hvad man får for pengene. A-kasserne fastlægger selv service- og kvalitetsniveau, og det vil i nogle tilfælde afspejle sig i prisen. Nogle a-kasser har en lang liste af tilbud til sine medlemmer, der rækker langt ud over de lovpligtige. Det kan være alt fra individuelt tilpasset karrierecoaching, netværksgrupper, foredrag og kurser i alt fra mindfulness og præsentationsteknik til jobtype- og branchespecifikke kurser og tiltag. Tilbud, der alle finansieres gennem dit medlemskontingent - altså den del af bidraget, der går til administration.

### Hvorfor blive medlem af en A-kasse?

Du bør først og fremmest blive medlem af en a-kasse for at sikre dig selv økonomisk i tilfælde af, at du mister dit job, bliver gravid og skal på barsel eller bliver ramt af sygdom eller en arbejdsskade. Det er nemlig ikke en selvfølge, at du er berettiget til kontanthjælp. Hvis blot du har en bil, et hus eller en andelslejlighed til en værdi på mere end 10.000 kr, er du ikke berettiget til kontanthjælp. Ligeledes heller ikke, hvis din ægtefælle eller samboende kæreste tjener mere om måneden, end hvad der svarer til dobbelt kontanthjælp. Sammen må I heller ikke have en formue på mere end 20.000 kr.

Dagpenge er modsat kontanthjælp uafhængig af både din formue og din ægtefælles indkomst. Derudover er dagpengesatsen også væsentligt højere end kontanthjælpssatsen.

### Hvem kan blive medlem af en A-kasse?

Alle kan blive medlem af en a-kasse, og hvis du ønsker at sikre dig selv økonomisk i tilfælde af, at du bliver ledig, bør du melde dig ind med det samme. Du skal nemlig have været medlem af en a-kasse i mindst et år og have arbejdet i minimum 1924 timer som fuldtidsforsikret eller 1258 timer som deltidsforsikret, før at du kan få dagpenge udbetalt - medmindre du er nyuddannet. De følgende afsnit handler om alt det, du bør vide om a-kasser, afhængig af om du er henholdsvis studerende, nyuddannet eller selvstændig.

### A-kasse for studerende

Det er en god idé at melde sig ind i en a-kasse allerede, når man er studerende - og ens lave indtægt som studerende er ingen hindring. Det er nemlig gratis at være medlem af mange af landets a-kasser, mens man er studerende. En af fordelene ved at være medlem af en a-kasse som studerende er, at hvis du har været medlem i mindst et år på det tidspunkt, hvor du afslutter din uddannelse, kan du få dagpenge udbetalt allerede dagen efter, at du har afsluttet din uddannelse. Hvis du har været medlem i kortere tid, har du først mulighed for at få dagpenge en måned efter, at du har afsluttet din uddannelse.

Dette er dog ikke den eneste fordel ved at melde sig ind i en a-kasse som studerende. Når du som studerende er medlem af en a-kasse, kan du nemlig også drage fordel af at kunne benytte alle a-kassens medlemstilbud helt gratis. Du kan gratis deltage i de kurser og på de workshops, som andre medlemmer betaler gennem deres kontingenter til a-kassen, og du kan få gratis rådgivning - eksempelvis i forhold til at finde et studierelevant job eller udforme ansøgning og cv. Det er derfor en god idé for dig, der er studerende at vælge en a-kasse, som har forstand på den branche, som du er ved at uddanne dig inden for.

Bemærk, at hvis du melder dig ind i en a-kasse, mens du er studerende, skal du huske at ændre din status i a-kassen til nyuddannet, når du afslutter din uddannelsen. Fristen for det er senest 14 dage efter endt uddannelse.

### A-kasse for nyuddannede

Er du nyuddannet, behøver du ikke have været medlem af en a-kasse i mindst et år for at kunne få udbetalt dagpenge. Kravet til dig, der er nyuddannet, er, at du skal have afsluttet en uddannelse af mindst 18 måneders varighed eller tre halvårlige semestre som fuldtidsstudium og have meldt dig ind i en a-kassen senest 14 dage efter, at du har afsluttet din uddannelse. Du skal dog være opmærksom på, at der er en økonomisk fordel ved at have været medlem i minimum et år, når du afslutter din uddannelse. Hvis du har det, har du nemlig mulighed for at modtage dagpenge allerede fra dagen efter, at du har afsluttet din uddannelse - det vil sige dagen efter, den dag du har fået din sidste karakter - enten mundtligt eller skriftligt.

Hvis du først melder dig ind i a-kassen på et senere tidspunkt - og senest 14 dage efter din uddannelse er afsluttet - kan du først få dagpenge en måned efter, at din uddannelse er afsluttet.

Uanset om du har meldt dig ind i en a-kasse for mere eller mindre end et år siden, skal du huske at give din a-kasse besked, når du bliver nyuddannet. Fristen for at meddele det til din a-kasse er 14 dage fra den dato, du afsluttede din uddannelse. Får du ikke gjort det inden for fristen, så gælder de normale regler, som beskrevet i afsnittet "Hvem kan blive medlem af en a-kasse".

Med en forhåndsgodkendelse fra din vejleder, kan du søge dagpenge, inden du har fået din sidste karakter, så alt er på plads den dag, du afslutter din uddannelse.

### A-kasser for selvstændige

Der findes a-kasser, som har specialiseret sig i at hjælpe selvstændige. A-kasser som Lederne og Virksom lægger vægt på, at de er a-kasser for selvstændige. Som selvstændig, skal du være opmærksom på, at du ikke kan få udbetalt dagpenge, medmindre du lukker eller sælger din virksomhed. Det vil sige, at du altså ikke har mulighed for at få dagpenge udbetalt i tilfælde af, at du i nogle perioder ikke har råd til at udbetale løn til dig selv. Gennem a-kassen, kan du som selvstændig altså kun sikre dig økonomisk i tilfælde af, at du skulle blive nødt til at lukke eller sælge din virksomhed. Dette er selvfølgelig en god tryghed at have, når du vælger at blive selvstændig og helt naturligt tænker "Tænk, hvis det lykkes", men også "Hvad nu hvis det ikke lykkes".

De fleste selvstændige vil dog gå rigtig langt for sin virksomhed og hellere leve meget skrabet lige til det sidste, frem for at lukke eller sælge. Er du i den situation, og ender du med at være nødt til at afvikle din virksomhed, skal du være opmærksom på, at hvis virksomheden i en længere periode har haft en lav omsætning, eller du har udbetalt en lav løn til dig selv, kan det have indflydelse på om og hvor meget, du kan få udbetalt i dagpenge.

Udover, at der stilles krav om, at du afvikler din virksomhed, skal du, for at få dagpenge udbetalt, have drevet din virksomhed i væsentligt omfang i 52 uger inden for de seneste 3 år. Ved "væsentligt omfang" forstås, at du skal have arbejdet i virksomheden i et omfang, som kan sidestilles med lønarbejde i mere end 30 timer om ugen. Det er den enkelte a-kasse, der vurderer, om du har drevet din virksomhed i væsentligt omfang. Du kan læse mere om de ting, som a-kassen bruger i dén vurdering på den enkelte a-kasses hjemmeside.

Såfremt, at du er berettiget til dagpenge, vil du få udbetalt dagpenge tre uger fra den dag, du afviklede virksomheden.

### A-kasse priser - Hvad koster det?

Et medlemskab hos en a-kasse koster typisk mellem 4-500 kr om måneden. Det du får ekstra for at betale mere for dit medlemskab er typisk et bredere udvalg af tilbud inden for kurser, workshops, foredrag og individuel coaching og/eller ekspertviden inden for dit fagområde. Der findes nemlig både tværfaglige a-kasser og fagligt afgrænsede a-kasser, hvoraf sidstnævnte typisk er lidt dyrere. Du kan se og sammenligne priser på a-kasser i oversigten over a-kasser her på siden. I oversigten vil du kunne se prisen på a-kassen, a-kassens score på trustpilot og hvilke faggrupper a-kassen beskæftiger sig med. Hvis a-kassen er gratis for studerende vil det også stå angivet.

Tværfaglige og fagligt afgrænsede a-kasser

Der findes både tværfaglige og fagligt afgrænsede a-kasser, som enten er jobtype- eller branchespecifikke. Akademikernes A-kasse, BUPL og Lederne er eksempler på fagligt afgrænsede a-kasser, mens Krifa, Ase og Det faglige hus er eksempler på tværsfaglige a-kasser. Fordelen ved de tværfaglige a-kasser er typisk, at de billigere, mens fordelen ved de faglige afgrænsede a-kasser er, at de er specialiseret i viden og problemstillinger, der er typiske for- og relateret til et specifikt fagområde eller branche. Hvad du skal vælge afhænger af, hvor vigtigt du synes, det er, at din a-kasse kender din branche samt, at de medlemstilbud de har, er skræddersyet til folk med din baggrund.

### Hvilken A-kasse er den bedste?

Hvilken a-kasse der er bedst afhænger af ens situation. Hvis du blot ønsker at være medlem for at kunne få udbetalt dagpenge, er det oplagt for dig blot at vælge den billigste a-kasse. Du kan finde den billigste a-kasse i oversigten over a-kasser her på siden. Hvis du derimod ønsker en a-kasse, der er ekspert inden for lige netop dit område, egner en branchespecifik a-kasse sig bedst til dig. Det fremgår af den enkelte a-kasses hjemmeside, hvorvidt den er branchespecifik eller ej - og i så fald hvilken branche/hvilke brancher, den beskæftiger sig med. På a-kassernes hjemmesider, kan du også læse nærmere om de tilbud, de har til sine medlemmer. Det er en god idé at undersøge hvilke tilbud, de forskellige a-kasser har, inden du beslutter dig for hvilken a-kasse, du vil have. Måske tænker du, at den billigste a-kasse er fint til dig, men ved nærmere undersøgelser finder du måske ud af, at der er en anden a-kasse, som har nogle medlemstilbud, som du finder attraktive og værd at betale ekstra for at få mulighed for at benytte.

### Hvad er forskellen mellem en a-kasse og en fagforening?

Fagforeninger bliver ofte forvekslet med a-kasser og omvendt, men faktisk er en a-kasse og en fagforening to vidt forskellige ting - og det er vigtigt at kende forskellen.

Når du er medlem af en a-kasse betaler du et kontingent for at sikre dig at kunne få dagpenge udbetalt, hvis du en dag står uden arbejde.

Når du er medlem af en fagforenig betaler du et kontingent for at have adgang til juridisk hjælp og bistand i forbindelse med dit arbejde. Det kan eksempelvis være rådgivning i forbindelse med juridiske tvister mellem, dig og din arbejdsgiver, rådgivning i forbindelse med lønforhandlinger og andre forhold i din ansættelseskontrakt eller i forbindelse med en uretmæssig fyring. Kort sagt, sørger en a-kasse altså for, at du er økonomisk sikret, hvis du mister dit job, mens en fagforening tager sig af forhold, der vedrører dit arbejde, når du er i arbejde - nemlig løn- og ansættelsesvilkår.

Du er ikke forpligtet til at være medlem af hverken en a-kasse eller en fagforening, men det er en god idé at være medlem af både en a-kasse og en fagforening, da alle kan komme ud for at miste sit arbejde eller få brug for en fagforenings ekspertise inden for løn og ansættelsesvilkår. Der er nemlig mange aspekter af ens arbejdsliv, der kan være svære at gennemskue - både juridiske og ikke juridiske, men man tænker typisk ikke over det, før man står midt i problemerne, og så er der ingen hjælp at hente.

### Vælge en a-kasse med eller uden fagforening?

Du kan vælge at blive medlem af en a-kasse og en fagforening hver sit sted - f.eks. kan du være medlem af CA A-kasse og have Frie Funktionærer som fagforening. Flere a-kasser tilbyder dog også medlemskab af fagforening hos dem, så du kan få a-kasse og fagforening samlet ét sted - f.eks hos 3F, Ase og Det faglige hus. Det er typisk billigere at have de to ting samlet ét sted og så er det samme sted, du skal henvende dig, hvis du har problemer med at være på eller uden for arbejdsmarkedet.

### Kan jeg skifte a-kasse?

JA, og du behøver ikke vente til at du har været medlem i et år. For at kunne få dagpenge, skal du bare have været medlem af en a-kasse i minimum et år, men det behøver ikke være den samme a-kasse i dét år. Din anciennitet følger dig fra a-kasse til a-kasse.

Hvis du vil skifte a-kasse, skal du blot kontakte den nye a-kasse og fortælle dem navnet på din nuværende a-kasse, så ordner den nye a-kasse alt det praktiske omkring dit skifte. A-kasser har typisk en formular på deres hjemmeside, som du nemt og hurtigt kan udfylde, hvis du ønsker at blive medlem hos dem, og ellers kan du skrive en mail eller ringe til dem.

Skiftet træder i princippet i kraft den dag, du anmoder den nye a-kasse om skiftet. Du vil dog typisk blive tilbudt at skifte ved udgangen af måneden eller indeværende betalingsperiode, så du slipper for dobbeltbetaling. Bemærk, at hvis du ikke er i job, kan du tidligst skifte med en måneds varsel.

## Alt om dagpenge

### Dagpenge rettigheder

Du har ret til at få dagpenge udbetalt, hvis du bliver arbejdsløs og enten:

* har været medlem af en a-kasse i minimum et år og opfylder beskæftigelseskravet om - som fuldtidsforsikret - at have arbejdet mindst 1924 timer inden for de seneste tre år eller - som deltidsforsikret - at have arbejdet mindst 1258 timer inden for de seneste tre år.

eller

* har afsluttet en uddannelse af mindst 18 måneders varighed og har meldt dig ind i a-kassen senest 14 dage efter afsluttet uddannelse.

Derudover skal du opfylde rådighedskravet og må ikke være selvforskyldt ledig.

Rådighedskravet dækker over, at du skal kunne dokumentere, at du står fuldt til rådighed for arbejdsmarkedet. Det gør du, når du:

* har bopæl og opholder dig i Danmark

* har udfyldt en ledighedserklæring gennem din a-kasse

* har meldt dig ledig på dit lokale jobcenter

* aktivt søger jobs

* kan starte på job med dags varsel

* deltager i de møder, aktiviteter og tilbud, som jobcenter og a-kasse indkalder dig til

Din a-kasse kan i den forbindelse stille krav til, hvor mange ansøgninger, du skal sende om ugen og/eller krav om, at du skal oplyse dem om,hos hvilke virksomheder og hvilke stillinger, du har søgt og bede dig fremvise konkrete ansøgninger.

### Hvor længe har jeg ret til dagpenge?

Du har ret til dagpenge i, hvad der svarer til to år i løbet af en periode på tre år. Denne periode kaldes referenceperioden. Dagpengeretten gøres op i timer, og de to år svarer som fuldtidsforsikret til 3848 timer og som deltidsforsikret til 3120 timer.

Du mister retten til dagpenge, når du har fået udbetalt dagpenge for alle disse timer eller når din referenceperiode slutter - og dét uanset om alle timerne er brugt eller ej.

### Er der mulighed for at forlænge dagpengeperioden?

Der er flere måder hvorpå, du kan forlænge dine dagpenge:

1. Du kan forlænge dine dagpenge, hvis du inden for dagpengeperiode - også kaldet referenceperioden - kommer i arbejdet. Det foregår således, at du optjener to timers ekstra dagpengeret pr. time, du arbejder. Får du, efter at have gået ledig i en periode, eksempelvis et arbejde af en uges varighed på 37 timer, så optjener du dagpengeret svarende til:

37 x 2 = 74 timers forlænget dagpengeperiode

De optjente timer, kan du bruge til at forlænge din dagpengeperiode i op et år - inden for en periode på to år efter den oprindelige dagpengeperiodes udløb. Du kan også vælge at gemme de optjente timer, til at du har timer nok til en ny dagpengeperiode. Alternativt kan du bruge nogle af timerne på at forlænge din nuværende dagpengeperiode og så gemme resten til en ny dagpengeperiode.

2. Du kan også forlænge dine dagpenge, hvis du har en gyldig grund hertil. Følgende grunde betragtes som gyldige:

* Perioder med barseldagpenge

* Perioder med dagpenge ved pasning af alvorligt sygt barn

* Perioder med støtte til at passe handicappet barn eller
 nærtstående, der ønsker at dø i eget hjem

* Sygdom i mere end 6 uger, hvis du modtager sygedagpenge

### Dagpengesatser 2017

Dagpengesatsen svarer til 90 % af din løn - dog maks 18.403 kr. om måneden. Tjener du minimum 22.230 kr. om måneden, vil du få udbetalt den højeste dagpengesats på de 18.403 kr., som er den højeste dagpengesats for fuldtidsforsikrede.

Der findes forskellige loft for dagepengesatsen afhængig af din situation; om du er _fuldtid_, _deltid_, _dimittend_ - herunder _forsøger_ eller _ikke forsøger_ eller _ung_. Se de højeste dagpengesatser her:

#### Max dagpengesats pr 1. juli 2017

<table style="width: 300px">
<tr>
<td>Fuldtid</td>
<td>18.403 kr.</td>
</tr>
<tr>
<td>Deltid</td>
<td>12.269 kr.</td>
</tr>
<tr>
<td>Dimittend - forsørger </td>
<td>15.090 kr.</td>
</tr>
<tr>
<td>Dimittend - ikke forsøger</td>
<td>13.158 kr.</td>
</tr>
<tr>
<td>Dimittend - deltid</td>
<td>10.061 kr.</td>
</tr>
<tr>
<td>Unge - fuldtid</td>
<td>9.202 kr.</td>
</tr>
<tr>
<td>Unge - deltid</td>
<td>6.135 kr.</td>
</tr>
</table>

### Dagpengesatser 2018

Dagpengesatsen svarer til 90 % af din løn - dog højst maksimumsatsen på 18.633 kr. om måneden.

Der findes forskellige loft for dagepengesatsen afhængig af din situation; om du er _fuldtid_, _deltid_, _dimittend_ - herunder _forsøger_ eller _ikke forsøger_ eller _ung_. Se de højeste dagpengesatser her:

#### Max dagpengesats pr 1. januar 2018

<table style="width: 300px">
<tr>
<td>Fuldtid</td>
<td>18.633 kr.</td>
</tr>
<tr>
<td>Deltid</td>
<td>12.422 kr.</td>
</tr>
<tr>
<td>Dimittend - forsørger </td>
<td>15.279 kr.</td>
</tr>
<tr>
<td>Dimittend - ikke forsøger</td>
<td>13.323 kr.</td>
</tr>
<tr>
<td>Dimittend - deltid</td>
<td>10.186 kr.</td>
</tr>
<tr>
<td>Unge - fuldtid</td>
<td>9.317 kr.</td>
</tr>
<tr>
<td>Unge - deltid</td>
<td>6.211 kr.</td>
</tr>
</table>

### Supplerende dagpenge

Supplerende dagpenge er til dig, der er delvist arbejdsløs. Du betragtes som delvist arbejdsløs, hvis du arbejder mindre end 29,6 timer om ugen. For at få udbetalt supplerende dagpenge, skal du, udover at arbejde mindre end 29,6 timer om ugen, også opfylde de normale krav, som nævnt under afsnittet "Dagpenge rettigheder. Derudover skal du også opfylde rådighedskravet. I det ligger der, at du skal stå fuldt til rådighed for arbejdsmarkedet. Får du tilbudt en fuldtidsstilling eller en stilling på flere timer, end din nuværende, skal du takke ja til stillingen med øjeblikkelig virkning.

For at det kan lade sig gøre, kan det være nødvendigt at få din arbejdsgiver til at lave en frigørelsesattest, hvori arbejdsgiver giver samtykke til, at det er muligt for dig at sige op med dags varsel i tilfælde af, at du finder en fuldtidsstilling eller en deltidsstilling på flere timer.

Du kan få supplerende dagpenge i op til 30 uger inden for en toårig periode.

### Krav til jobansøgning

For at få dagpenge, skal du kunne arbejde, være aktivt jobsøgende, og opfylde følgende:

* Bo og opholde sig i Danmark

* Være tilmeldt jobcenteret og have et aktivt CV på jobnet.dk

* Møde op til alle de samtaler din a-kasse og jobcenteret indkalder dig til.

* Stå til rådighed for arbejdsmarkedet. Her menes der, at du skal kunne overtage rimeligt arbejde med 1 dags varsel.

* Søge konkrete jobs, som du er henvist til af din a-kasse, dit jobcenter eller andre aktører.

* Du skal ikke udelukkende søge sæsonarbejde, job hos èn bestemt arbejdsgiver eller jobs i udlandet.

* Har du en uddannelse eller erhvervserfaringer inden for et bestemt fagområde, skal du søge jobs inden for dette områder.

Du skal altså være til rådighed og søge alt det arbejde, som du har kvalifikationer til at varetage. Du bestemmer selv hvordan du søger, om det er skriftligt, personligt eller telefonisk. Når det så er sagt, skal du huske at søge på den måde, der er almindelig inden for de områder, hvor du søger jobs. Hvis du ikke er så erfaren i jobansøgninger og har andre spørgsmål i forbindelse med jobsøgningen, er der vejledning at hente både hos din a-kasse og jobcenteret.

### Aktivering

Som arbejdsløs har du pligt og ret til at deltage i aktivering. Når du er i aktivering forbedres dine muligheder for at komme i arbejde. I samarbejde med dit jobcenter fastlægges dit aktiveringsforløb. Det er her vigtigt, at du overholder de aftaler I sammen laver, da du ellers mister din ret til dagpenge.

Der er tre former for aktivering:

* Virksomhedspraktik

* Job med løntilskud

* Vejledning og opkvalificering

Er du mellem 30 og 50 år skal senest aktiveres af jobcenteret efter 26 ugers ledighed. Er du derimod under 30 år eller over 50 år har du ret og pligt til senest at blive aktiveret, efter en ledighed på 13 uger.

Du skal være opmærksom på, at selvom du er i aktivering, kan du ikke læne dig tilbage og vente på, at du får et job. Du har nemlig pligt til fortsat at søge arbejde og tage imod arbejde, som jobcenteret formidler til dig.

Du skal ligeledes være opmærksom på dine rettigheder, hvis du har et deltidsjob. Har du et deltidsjob på mindst 20 timer om ugen, har du ikke længere pligt, men dog stadig ret, til aktivering. Har du derimod et arbejde, hvor timerne varierer, bortfalder din pligt til aktivering, hvis dit arbejde i gennemsnit svarer til mindst 20 timer om ugen beregnet over en måned. Har du arbejde på mindre end 20 timer om ugen, skal du i aktivering indtil du får fuldtid.

Får du et deltidsarbejde under dit aktiveringsforløb, skal du sammen med dit jobcenter eller din anden aktør revidere din aktiveringsplan, så den tager hensyn til dit arbejde.

## A-kasse og orlov

Der findes forskellige typer af orlov, hvorunder det er muligt at få dagpenge. Barselsorlov er nok den mest kendte type orlov. Læs mere om barselsorlov under "Rettigheder og pligter på dagpenge".

Der findes også en orlovstype, der hedder børnepasningsorlov - hvor du udskyder noget af den orlov, som du har ret til i forbindelse med dit barns fødsels samt orlov til pasning af syge og døende pårørende. Ved sidstnævnte kan du få udbetalt et plejevederlag, som udbetales af kommunen. Børnepasningsorlov kan afholdes af både dem, der er beskæftigede og dem, der er ledige med børn i op til 8-års alderen. Man kan udskyde mellem 8 og 13 uger.

### Rettigheder og pligter på dagpenge

Nedenfor kan du læse om hvilke rettigheder og pligter du har som dagpengemodtager, hvis du skal holde ferie, bliver syg eller skal holde barsel.

#### Ferie

Du kan naturligvis holde ferie, selvom du er på dagpenge. Ønsker du det, kan du:

* Bruge de feriepenge, som du har optjent hos en arbejdsgiver.

* Søge om at få udbetalt de feriedagpenge, som du har optjent i a-kassen.

* Holde fri for egen regning

Det er vigtigt, at du husker at informere om dine ferieplaner via jobnet.dk senest 14 dage før feriens første dag. Hvis du gør dette, får din a-kasse automatisk besked, og du behøver derfor ikke foretage dig yderligere.

Meddeler du ferie til jobcenteret mindre end 14 dage før første feriedag, har du pligt til at deltage i møder og arrangementer som din a-kasse, jobcenteret eller andre aktører afholder, også selvom du holder ferie. Hvis du ikke deltager i disse, vil du som konsekvens miste din ret til **dagpenge** i en periode. Derudover skal din a-kasse have besked om din ferie, inden den starter.

Hvis du meddeler ferie på en dag, hvor jobcenteret, din a-kasse eller en anden aktør forinden har indkaldt til et møde eller en aktivitet i den ønskede ferieperiode, har du pligt til at deltage, uanset om du har meldt ferie med mere end 14 dages varsel.

#### Sygdom

I tilfælde af sygdom, skal du melde dig syg via jobnet.dk. Dette skal du gøre allerede på første sygedag og også selvom du kun er syg for en enkelt dag. Når du har meldt dig syg på jobnet vil din A-kasse automatisk få besked om din sygemelding.

Om du er berettiget til dagpenge under din sygeperiode afhænger af, om du er helt eller delvist ledig. Hvis du intet deltidsjob har, er du berettiget til dagpenge fra din a-kasse i de første 14 sygedage. Er du ikke rask efter de 14 dage, får du derefter sygedagpenge gennem din kommune. Er det tilfældet, vil din kommune sende dig et ansøgningsskema om sygedagpenge, som du skal sende retur til dem inden for otte dage efter, at brevet er modtaget. Har du et deltidsarbejde og får blot supplerende dagpenge, kan du ikke få dagpenge fra din a-kasse. I stedet skal du have sygedagpenge fra din kommune.

Når du er rask igen, skal du, for igen at få dagpenge fra din a-kasse, melde dig rask på jobnet.dk.

#### Barsel

Under barsel, har du mulighed for at modtage barselsdagpenge. Det er Udbetaling Danmark som betaler dig dagpenge i din barselsperiode efter samme sats som dine ydelser i din a-kasse. Beløbet er altså det samme. Forskellen er, at du på barsel ikke står til rådighed for arbejdsmarkedet.

En orlov med barselsdagpenge er inddelt i fire stadier:

* Til mor: Graviditetsorlov 4 uger før forventet fødsel.

* Til moren: Barselsorlov i 14 uger efter fødslen

* Til faren: Fædreorlov i 2 sammenhængende uger inden for de første 14 uger efter fødslen.

* Til deling: Forældreorlov i 32 uger, som forældrene kan dele mellem sig.

Du skal senest 8 uger efter fødslen anmelde dit fravær/barsel til din a-kasse.

### Karantæne

Karantæne betyder, at du ikke får udbetalt dagpenge i en periode, hvor du ellers ville have haft ret til at modtage dagpenge. Du får karantæne, hvis du enten:

* **Er selvforskyldt ledig**

Det dækker både over, hvis du siger op uden det man i dagpengesystemet kalder *en gyldig grund *eller selv er skyld i en afskedigelse fra din arbejdsgiver - f.eks. hvis du undlader at møde på arbejde. Hvis du har accepteret en for kort opsigelsesvarsel betragtes du også som selvforskyldt ledig.

eller

* **Ikke imødekommer de krav, der er til dig som ledig**

Hvis du uden en gyldig grund eksempelvis afslår et job formidlet af jobcenteret eller udebliver fra tilbud, kurser eller samtaler hos a-kasse eller jobcenter får du karantæne.

Får du karantæne mister du retten til dagpenge i 90 timer som deltidsforsikret og 111 timer som fuldtidsforsikret - svarende til 3 uger. Hvis du to gange inden for 12 måneder får karantæne, mister du fuldstændig retten til dagpenge.

Har du planer om at sige din stilling op, bør du først undersøge, om du har hvad der, i dagpengesystemet, betragtes som en gyldig grund til det, så du undgår karantæne.

### A-kasse skattefradrag

Du kan trække dit a-kasse kontingent fra i SKAT. Kontingentet bliver automatisk angivet på din årsopgørelse. Du skal dog selv skrive dit kontingent til a-kassen i felt 439 i din forskudsopgørelse, når du begynder at betale for et a-kasse medlemskab. Modsat fagforeninger, er der ikke noget loft for det beløb, som du kan få fradrag for, når det gælder a-kasse kontingenter.

### Dagpenge i udlandet

#### Kan man modtage dagpenge, når man opholder sig i udlandet?

Ja! Du har på visse betingelser mulighed for at få udbetalt dagpenge fra din danske a-kasse, mens du opholder dig i udlandet i op til tre måneder, hvis du er arbejdsløs og vil søge arbejde i et andet EØS-land, på Færøerne eller i Schweiz. EØS landene omfatter EU-landene samt Island, Liechtenstein og Norge.

#### Hvordan får man udbetalt dagpenge i udlandet?

For at få udbetalt dagpenge, mens du opholder og søger job i et andet EØS-land, skal du stille dig til rådighed for arbejdsmarkedet i det pågældende land og have et PD U2 dokument, som er din dokumentation for, at du har ret til at få udbetalt dagpenge fra din danske a-kasse, mens du opholder dig i udlandet i op til tre måneder.

Betingelser for at få udstedt et PD U2 dokument er, at:

* Du er medlem af en a-kasse

* Du har ret til dagpenge på planlagt afrejsedato

* Du er statsborger i et EØS-land eller Schweiz og bor og opholder dig i Danmark indtil afrejsedagen

* Du har været tilmeldt jobcentret som fuldtidsarbejdsløs i mindste fire uger før planlagt afrejsedato.

Bemærk, at der ikke er nogen fire ugers regel, hvis du har ret til dagpenge og det er Færøerne, du vil til.

Bemærk også, at du kan få dispensation for fire ugers reglen, hvis det er et af de andre EØS lande eller Schweiz, du vil til, hvis enten:

* Din ægtefælle eller samlever har fået mere end fem ugers ansættelse eller skal begynde en uddannelse af minimum 18 måneders varighed i det land, som du ønsker at fortsætte din jobsøgning i.

* Du kan dokumentere, at du skal til jobsamtale i det pågældende land

* Du er statsborger i det land, som du ønsker at rejse til og fortsætte din jobsøgning i, og du har været tilmeldt jobcenteret i minimum en uge, efter at du blev ledig.

* Du allerede har fået arbejde enten af kortere varighed eller deltid i det pågældende lang og arbejdet ikke medfører, at du bliver arbejdsløshedsforsikret

Du kan tidligst søge om at få udstedt PD U2 dokumentation 4 uger før planlagt afrejsedato. Opfylder du ovenstående betingelser og får PD U2 udstedt, skal du, for at få udbetalt dagpengene i udlandet, tilmelde dig arbejdsformidlingen i det land, du rejser til, senest syv dage efter den startdato, som der står i PD U2. Gør du det ikke det, vil dagpengene først blive udbetalt, når du har tilmeldt dig arbejdsformidlingen.

#### Hvis du får arbejdet i udlandet

Tager du til udlandet som jobsøgende med dine danske dagpenge og finder arbejde der, vil du ikke længere være berettiget til dagpenge fra din danske a-kasse. Du skal i stedet sørge for at blive arbejdsløshedsforsikret, der hvor du får arbejde.

Får du job i udlandet skal du generelt altid sørge for at sætte dig grundigt ind i reglerne for arbejdsløshedsforsikring i det pågældende land. Det gælder også hvis du er selvstændig og vil drive forretning i udlandet. Er du ikke forsikret korrekt, kan du miste din ret til dagpenge, men også til at gå på efterløn.

### Forskellen på kontanthjælp og dagpenge

Der er alt for mange, der enten ikke kender forskellen på kontanthjælp og dagpenge eller som fejlagtigt tror, at alle, der bliver arbejdsløse, kan få kontanthjælp, og derfor ikke mener, at det nødvendigt at være medlem af en a-kasse. Men det er det! Et medlemskab hos en a-kasse er den bedste måde at sikre sig selv økonomisk i tilfælde af, at du mister dit job, bliver gravid og skal på barsel eller bliver ramt af sygdom eller arbejdsskade.

Forskellen på kontanthjælp og dagpenge er nemlig blandt andet, at din ret til kontanthjælp er afhængig af din formue og din samboende kæreste/ægtefælles indkomst, mens dette ingen betydning har for din ret til dagpenge.

Hvis blot du har en bil, et hus eller en andelslejlighed eller en opsparing til en værdi på mere end 10.000 kr, er du ikke berettiget til kontanthjælp. Det forventes i stedet at du sælger dine værdier og leve af indtægterne fra salget. Først når disse penge er sluppet op, er du berettiget til kontanthjælp og kun hvis din ægtefælle eller samboende kæreste tjener mindre om måneden, end hvad der svarer til dobbelt kontanthjælp. Gør han/hun ikke det, skal vedkommende forsørge dig. I må sammen heller ikke have en formue på mere end 20.000 kr.

Bliver du arbejdsløs, men er på grund af din formue eller din samboende partner/ægtefælles indtægt ikke berettiget til kontanthjælp, står du altså helt uden indtægt, hvis ikke du er meldt ind i en a-kasse og har været det i minimum et år.

En anden ting, der taler for at være medlem af en a-kasse er, at dagpengesatsen er væsentligt højere end kontanthjælpssatsen.
`}</Markdown>
      </Paper>
    );
  }
}
